.cw{aspect-ratio:1/1;}